"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.longToShortAbbreviation = void 0;
const constants_1 = require("./constants");
const numberOfTimezones = constants_1.timezonesLongAbbreviations.length;
const longToShortAbbreviation = (dateTime) => {
    // traditional for loop for performance reasons
    for (let i = 0; i < numberOfTimezones; i++) {
        const longAbbr = constants_1.timezonesLongAbbreviations[i];
        // checking if the current long abbreviation is part of the date time string
        const index = dateTime.indexOf(longAbbr);
        // if yes, we recompose the string with the short abbreviation
        // using slice instead of replace for performance reasons
        if (index !== -1) {
            return `${dateTime.slice(0, index)}${constants_1.timezoneMapping[longAbbr]}${dateTime.slice(index + longAbbr.length)}`;
        }
    }
    return dateTime;
};
exports.longToShortAbbreviation = longToShortAbbreviation;
//# sourceMappingURL=utils.js.map